export const environment = {
  production: true,
  apiUrl: "https://pedics-labs.com",
  stripePublicKey: "pk_live_pmBuybdedFTOEdSCJP2pJxoJ"
};
